/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_UnitsInputs */

const cs_property_registry_units = /** @type {(inputs: Property_Registry_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednotky`)
};

const en_property_registry_units = /** @type {(inputs: Property_Registry_UnitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units`)
};

/**
* | output |
* | --- |
* | "Units" |
*
* @param {Property_Registry_UnitsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_units = /** @type {((inputs?: Property_Registry_UnitsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_UnitsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_units(inputs)
	return cs_property_registry_units(inputs)
});